import {FC,useState} from "react";
import {
  Box,
  Button,
  Dialog,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import cross from "../../assets/images/cross.svg";
import useStyles from "../Styles/ProjectModalStyles";
import scanner from "../../assets/images/scanner.png";

const TakePicture:FC = () => {
  const theme = useTheme();
  const classes = useStyles();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Box component="section">
        <Button variant="outlined" color="primary" onClick={handleClickOpen}>
          Take Photo
        </Button>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.modalpages}
        >
          <Box
            ml={isActive ? "20px" : 7}
            my={isActive ? "20px" : 7}
            mr={isActive ? "20px" : 4}
            className="relative-box"
          >
            {!isActive && (
              <img
                src={cross}
                alt=""
                className="cross-icon"
                onClick={handleClose}
              />
            )}
            <ProjectPoolHeading title1="Take " title2="A Picture" />
            <img src={scanner} className="img-fluid" alt="scanner" />
            
            <Box mt={isActive ? 3 : 5}>
              <Button
                onClick={handleClose}
                variant="contained"
                color="secondary"
                className="button-buy"
              >
                Capture
              </Button>
              <Button
                onClick={handleClose}
                variant="outlined"
                color="secondary"
                className={`button-buy ${isActive ? 'ml-0 mt-12' : 'ml-22'}`}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default TakePicture;
